import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';
import BreakpointHelper from '../../00_utilities/helpers/BreakpointHelper';

class Tile {
    constructor(elem) {
        this.elem = elem;
        this.breakpoints = {
            'element-breakpoint': 820,
        };
    }

    init() {
        if (this.elem.classList.contains('tile-container--animation')) {
            const resizeSensitiveFunctions = [this.setTileTransformValue];
            this.resizeHandling(resizeSensitiveFunctions);
            this.setTileTransformValue();
        }
    }

    setTileTransformValue() {
        const tiles = this.elem.querySelectorAll('.tile');

        for (const element of tiles) {
            const elementTitle = element.querySelector('.tile__title');
            const elementTitleStyle = window.getComputedStyle
                ? getComputedStyle(elementTitle, null) : elementTitle.currentStyle;
            const elementTitlePadding = parseInt(elementTitleStyle.paddingBottom, 10);

            const text = element.querySelector('.tile__description');
            const textHeight = text.offsetHeight;

            const transform = elementTitlePadding + textHeight;
            element.style.setProperty('--transformY', transform);
        }
    }

    resizeHandling(resizeSensitiveFunctions) {
        let aboveBreakpoint = BreakpointHelper.aboveBreakpoint(this.breakpoints['element-breakpoint']);

        window.addEventListener('resize', GeneralHelper.throttle(() => {
            const breakpointInfo = BreakpointHelper.breakpointCrossed(
                this.breakpoints['element-breakpoint'],
                aboveBreakpoint,
            );
            aboveBreakpoint = breakpointInfo.aboveBreakpoint;

            if (aboveBreakpoint) {
                resizeSensitiveFunctions.forEach((func) => {
                    func.call(this);
                });
            }
        }, 200));
    }
}

export default Tile;
